import { render } from "./Threads.vue?vue&type=template&id=25b29c4f"
import script from "./Threads.vue?vue&type=script&lang=js"
export * from "./Threads.vue?vue&type=script&lang=js"

import "./Threads.vue?vue&type=style&index=0&id=25b29c4f&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__